import { renderHome } from "./home-app";
import { StorefrontApp } from "./storefront-app";
import { SubscribeApp } from "./subscribe-app";
import "./styles.css";

if (window.self !== window.top || new URLSearchParams(window.location.search).has("embed")) {
  document.documentElement.classList.add("is-embed");
}

const root = document.getElementById("app");
if (!root) {
  throw new Error("#app is missing");
}

const path = window.location.pathname.replace(/\/$/, "") || "/";
if (path === "/subscribe") {
  void new SubscribeApp(root).init();
} else if (path.startsWith("/s/")) {
  void new StorefrontApp(root).init();
} else {
  renderHome(root);
}
